/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiCustomListScreeningFieldType } from './InternalApiCustomListScreeningFieldType';
import {
    InternalApiCustomListScreeningFieldTypeFromJSON,
    InternalApiCustomListScreeningFieldTypeFromJSONTyped,
    InternalApiCustomListScreeningFieldTypeToJSON,
    InternalApiCustomListScreeningFieldTypeToJSONTyped,
} from './InternalApiCustomListScreeningFieldType';

/**
 * 
 * @export
 * @interface InternalApiCustomListScreeningField
 */
export interface InternalApiCustomListScreeningField {
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomListScreeningField
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomListScreeningField
     */
    path: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomListScreeningField
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomListScreeningField
     */
    code?: string;
    /**
     * 
     * @type {InternalApiCustomListScreeningFieldType}
     * @memberof InternalApiCustomListScreeningField
     */
    type?: InternalApiCustomListScreeningFieldType;
    /**
     * 
     * @type {string}
     * @memberof InternalApiCustomListScreeningField
     */
    rule?: string;
}



/**
 * Check if a given object implements the InternalApiCustomListScreeningField interface.
 */
export function instanceOfInternalApiCustomListScreeningField(value: object): value is InternalApiCustomListScreeningField {
    if (!('path' in value) || value['path'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function InternalApiCustomListScreeningFieldFromJSON(json: any): InternalApiCustomListScreeningField {
    return InternalApiCustomListScreeningFieldFromJSONTyped(json, false);
}

export function InternalApiCustomListScreeningFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCustomListScreeningField {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'path': json['path'],
        'name': json['name'],
        'code': json['code'] == null ? undefined : json['code'],
        'type': json['type'] == null ? undefined : InternalApiCustomListScreeningFieldTypeFromJSON(json['type']),
        'rule': json['rule'] == null ? undefined : json['rule'],
    };
}

export function InternalApiCustomListScreeningFieldToJSON(json: any): InternalApiCustomListScreeningField {
    return InternalApiCustomListScreeningFieldToJSONTyped(json, false);
}

export function InternalApiCustomListScreeningFieldToJSONTyped(value?: InternalApiCustomListScreeningField | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'path': value['path'],
        'name': value['name'],
        'code': value['code'],
        'type': InternalApiCustomListScreeningFieldTypeToJSON(value['type']),
        'rule': value['rule'],
    };
}

